import { Tooltip } from "antd"
import { TriangleAlertSmallIcon } from "components/ui/icons/Warning/TriangleAlertSmallIcon"
import { defaultTooltipStyles, getSidebarTooltipContainer } from "components/ui/customWebviewer/shared/shadowTooltip"
import {
	EREF_NOT_REFERENCED_LABEL,
	EREF_NOT_REFERENCED_MESSAGE,
} from "components/ui/customWebviewer/shared/ErefNotReferencedIndicator/erefNotReferenced.helpers"
import style from "./ErefNotReferencedIndicator.module.scss"

export const ErefNotReferencedIndicator = () => (
	<Tooltip
		title={EREF_NOT_REFERENCED_MESSAGE}
		placement="top"
		getPopupContainer={getSidebarTooltipContainer}
		styles={defaultTooltipStyles}
	>
		<span className={style.indicator}>
			<TriangleAlertSmallIcon title={EREF_NOT_REFERENCED_LABEL} />
		</span>
	</Tooltip>
)
